import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { LTLAccessorial } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type GetAccessorialsResponse = LTLAccessorial[];

/** Backend query name; for Mohawk 3G the value must be the customer's ExternalID (not ExternalTmsID). */
export type GetCustomerLTLAccessorialsParams = {
  customerExternalTmsId?: string;
};

export async function getCustomerLTLAccessorials(
  params?: GetCustomerLTLAccessorialsParams
): Promise<Result<GetAccessorialsResponse, ApiError>> {
  try {
    const response = await axios.get<GetAccessorialsResponse>(
      '/quote/ltl/accessorials',
      {
        params:
          params?.customerExternalTmsId != null &&
          params.customerExternalTmsId !== ''
            ? { customerExternalTmsId: params.customerExternalTmsId }
            : undefined,
      }
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getCustomerLTLAccessorials' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get LTL accessorials' });
    }

    return err({
      message: error.response?.data.message || 'Failed to get LTL accessorials',
    });
  }
}
